<section class="register-body">
    <h2 class="font-semibold m-0" style="display: flex; align-items: center;">
      <button mat-icon-button (click)="state.emit('request');"><mat-icon>arrow_left</mat-icon></button>
      <!-- <mat-icon matRipple (click)="verifying = false;">arrow_left</mat-icon> -->
      <span style="width: 100%;">Create account</span>
      <div style="min-width: 40px; height: 1px;"></div><!--spacer-->
    </h2>

    <form class="register-form" [formGroup]="form" (ngSubmit)="createAccount()">

      <!-- Email -->
      <div class="register-input">
        <mat-icon color="primary">email</mat-icon>
        <input matInput type="email" autocomplete="email" formControlName="email" placeholder="Email">
      </div>
      <ng-container *ngTemplateOutlet="errorRender; context: { $implicit: 'email', label: 'Email' }"></ng-container>

      <!-- First Name -->
      <div class="register-input">
        <mat-icon color="primary">person</mat-icon>
        <input matInput type="text" autocomplete="given-name" formControlName="name" placeholder="First Name">
      </div>
      <ng-container *ngTemplateOutlet="errorRender; context: { $implicit: 'name', label: 'First name' }"></ng-container>

      <!-- Last Name -->
      <div class="register-input">
        <mat-icon color="primary">person</mat-icon>
        <input matInput type="text" autocomplete="family-name" formControlName="surname" placeholder="Last Name">
      </div>
      <ng-container *ngTemplateOutlet="errorRender; context: { $implicit: 'surname', label: 'Last name' }"></ng-container>


      <!-- Date of Birth -->
      <div class="register-input" [class.overlay-open]="dobPicker.opened">
        <mat-icon color="primary" (click)="dobPicker.open()">event</mat-icon>
        <div class="overlay" (click)="dobPicker.open()" (focus)="dobPicker.open()" tabIndex="0">
        </div>
        <input class="cosmetic" matInput [matDatepicker]="dobPicker" placeholder="Date of Birth" [formControl]="dob" [min]="minDob" [max]="maxDob" style="pointer-events: none; user-select: none;" tabIndex="-1">
        <mat-datepicker class="cosmetic" #dobPicker startView="multi-year" [startAt]="maxDob"></mat-datepicker>
      </div>
      <ng-container *ngTemplateOutlet="errorRender; context: { $implicit: 'dob', label: 'Date of Birth' }"></ng-container>

      <!-- Gender -->
      <div class="register-input">
        <mat-icon color="primary">attribution</mat-icon>
        <div style="height: 50px; cursor: pointer; width: 100%; display: flex; align-items: center;" (click)="genderSelect.open()">
          <mat-select #genderSelect formControlName="gender" placeholder="Gender">
            <mat-option value="Male">Male</mat-option>
            <mat-option value="Female">Female</mat-option>
            <mat-option value="Unspecified">Unspecified</mat-option>
          </mat-select>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="errorRender; context: { $implicit: 'gender', label: 'Gender' }"></ng-container>

      <!-- Tourist -->
      <div class="register-input">
        <mat-icon color="primary">house</mat-icon>
        <div style="height: 50px; cursor: pointer; width: 100%; display: flex; align-items: center;" (click)="touristSelect.open()">
          <mat-select #touristSelect formControlName="tourist" placeholder="Do you live in Malta?">
            <mat-option [value]="true">I'm coming to Malta for a holiday</mat-option>
            <mat-option [value]="false">I live in Malta</mat-option>
          </mat-select>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="errorRender; context: { $implicit: 'tourist', label: 'Resident/Tourist' }"></ng-container>


      <!-- Country -->
      @if(form.get('tourist')!.value === true){
        <div class="register-input as-country">
          <lib-country-list class="w-full" [selectedCountryCode]="'mt'" [countryListConfig]="{ hideCode: true, hideDialCode: true }" [selectedCountryConfig]="{ hideCode: true, hideDialCode: true }" (onCountryChange)="form.get('country')!.setValue($event.name||'Malta')"></lib-country-list>
        </div>
        <ng-container *ngTemplateOutlet="errorRender; context: { $implicit: 'country', label: 'Country' }"></ng-container>
      } @else {
        <!-- City -->
        <div class="register-input">
          @if(selectedCity(); as city){
            <mat-icon color="primary" svgIcon="logo:{{city.country.toLowerCase()}}"></mat-icon>
          } @else {
            <mat-icon color="primary">place</mat-icon>
          }
          <div class="w-full f-cross-center" style="height: 50px; cursor: pointer;" (click)="citySelect.open()">
            <mat-select #citySelect formControlName="city" placeholder="City">
              <mat-select-trigger>
                {{form.get('city')!.value}}
              </mat-select-trigger>
              @for(city of cities; track city.actual||city.name){
                <mat-option [value]="city.actual||city.name">
                  <div class="f-cross-center">
                    <mat-icon svgIcon="logo:{{city.country.toLowerCase()}}"></mat-icon>
                    <div>
                      <p class="m-0">{{city.name}}</p>
                      <small paint="#18192190">{{city.country}}</small>
                    </div>
                  </div>
                </mat-option>
              }
            </mat-select>
          </div>
        </div>
        <ng-container *ngTemplateOutlet="errorRender; context: { $implicit: 'city', label: 'City' }"></ng-container>
      }

      <br/>

      <button mat-flat-button color="primary" rounded class="login-button" type="submit" [disabled]="loading()">
        <span class="font-semibold">{{loading() ? 'Loading...' : 'Create Account'}}</span>
      </button>
      <br/>
      <p style="text-align:center; font-size: 90%;">When you join, we'll email and SMS you about our general or tailored offers, news and services. You can adjust your communication preferences at any time from your profile on cloudigo. When you join you're consenting to our <a routerLink="/terms-and-conditions" color="primary">Terms & Conditions</a> and our <a routerLink="/privacy-policy" color="primary">Privacy Policy</a></p>
      <br/>
    </form>
  </section>


<ng-template #errorRender let-field let-label="label">
  @if(form.get(field)?.touched && form.get(field)?.errors; as error){
    <mat-error>
      @if(error.required){
        {{label}} is required
      } @else if(error.email){
        {{label}} is not valid
      } @else if(error.bad){
        Please enter a different {{label}}
      } @else if(error.matDatepickerMax){
        You must be at least 16 years old to register
      } @else if(error.matDatepickerMin){
        You can't possibly be this old... right?
      } @else if(error.age){
        You must be at least 16 years old
      } @else {
        {{label}} is invalid
      }
    </mat-error>
  } @else {
    <mat-hint>&nbsp;</mat-hint>
  }
</ng-template>